// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Vpx0","head":"Table_head__3Ixqw","col":"Table_col__2dgI7"};